import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  filterLabelsForCurrentSiteSelector,
  filterUsersForCurrentSiteSelector,
  labelsForCurrentSiteSelector,
  lineIdsForCurrentSiteSelector,
  lineForCurrentSiteSelector,
  membershipsForCurrentFactorySelector,
  pathSelector,
  isAdminSelector,
  isManagerSelector,
} from '../selectors';
import {
  addLabelToFilterInCurrentSite,
  addUserToFilterInCurrentSite,
  createLabelInCurrentSite,
  createLineInCurrentSite,
  deleteLabel,
  moveDevice,
  moveLine,
  removeLabelFromFilterInCurrentSite,
  removeUserFromFilterInCurrentSite,
  updateLabel,
} from '../actions/entry';
// import SiteKanban from '../components/SiteKanban';
import SiteDiagram from '../components/SiteDiagram';

const mapStateToProps = (state) => {
  const { deviceId } = pathSelector(state);
  const allFactoryMemberships = membershipsForCurrentFactorySelector(state);
  const allLabels = labelsForCurrentSiteSelector(state);
  const lineIds = lineIdsForCurrentSiteSelector(state);
  const lines = lineForCurrentSiteSelector(state);
  const filterUsers = filterUsersForCurrentSiteSelector(state);
  const filterLabels = filterLabelsForCurrentSiteSelector(state);
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);

  return {
    lines,
    lineIds,
    filterUsers,
    filterLabels,
    allFactoryMemberships,
    allLabels,
    isDeviceModalOpened: !!deviceId,
    canEdit: isAdmin || isManager,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onLineCreate: createLineInCurrentSite,
      onLineMove: moveLine,
      onDeviceMove: moveDevice,
      onUserToFilterAdd: addUserToFilterInCurrentSite,
      onUserFromFilterRemove: removeUserFromFilterInCurrentSite,
      onLabelToFilterAdd: addLabelToFilterInCurrentSite,
      onLabelFromFilterRemove: removeLabelFromFilterInCurrentSite,
      onLabelCreate: createLabelInCurrentSite,
      onLabelUpdate: updateLabel,
      onLabelDelete: deleteLabel,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteDiagram);
